export enum AutoAssignmentType {
  ALL_TEAM_MEMBERS = 'auto_assign_all_team_members_type',
  TEAM_MEMBERS_GROUPS = 'auto_assign_team_members_groups_type',
}
